var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseCaseSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V20H4V21C4 24.866 7.134 28 11 28H14V26H11C8.239 26 6 23.761 6 21Z",
    fill: "#07A0C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11V12H26V11C26 7.134 22.866 4 19 4H16V6H19C21.761 6 24 8.239 24 11Z",
    fill: "#07A0C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H5C3.343 11 2 12.343 2 14V16H4V14C4 13.448 4.448 13 5 13H11C11.552 13 12 13.448 12 14V16H14V14C14 12.343 12.657 11 11 11Z",
    fill: "#07A0C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C9.105 4 10 4.895 10 6C10 7.105 9.105 8 8 8C6.895 8 6 7.105 6 6C6 4.895 6.895 4 8 4ZM8 10C10.209 10 12 8.209 12 6C12 3.791 10.209 2 8 2C5.791 2 4 3.791 4 6C4 8.209 5.791 10 8 10Z",
    fill: "#07A0C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25H21C19.343 25 18 26.343 18 28V30H20V28C20 27.448 20.448 27 21 27H27C27.552 27 28 27.448 28 28V30H30V28C30 26.343 28.657 25 27 25Z",
    fill: "#07A0C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20C26 21.105 25.105 22 24 22C22.895 22 22 21.105 22 20C22 18.895 22.895 18 24 18C25.105 18 26 18.895 26 20ZM20 20C20 22.209 21.791 24 24 24C26.209 24 28 22.209 28 20C28 17.791 26.209 16 24 16C21.791 16 20 17.791 20 20Z",
    fill: "#07A0C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseSales);
export default __webpack_public_path__ + "static/media/use-case-sales.fb68aebf5ba43547965edb13953cc16c.svg";
export { ForwardRef as ReactComponent };